const MLA = 'MLA';
const MLB = 'MLB';
const MLM = 'MLM';

const messagesErrorScreen = (siteId) => {
  switch (siteId) {
    case MLA:
      return {
        title: '¡Ups! hubo un error',
        description: 'Intentalo más tarde',
      };
    case MLB:
      return {
        title: 'Ops! Ocorreu um erro',
        description: 'Tente novamente mais tarde',
      };
    case MLM:
      return {
        title: '¡Ups! hubo un error',
        description: 'Inténtalo más tarde',
      };
    default:
      return {
        title: '¡Ups! hubo un error',
        description: 'Inténtalo más tarde',
      };
  }
};

const messagesNotFound = (siteId) => {
  switch (siteId) {
    case MLA:
      return {
        title: 'Parece que esta página no existe',
        text: 'Volver atrás',
      };
    case MLB:
      return {
        title: 'Parece que esta página não existe',
        text: 'Voltar atrás',
      };
    case MLM:
      return {
        title: 'Parece que esta página no existe',
        text: 'Volver atrás',
      };
    default:
      return {
        title: 'Parece que esta página no existe',
        text: 'Volver atrás',
      };
  }
};

module.exports = {
  messagesErrorScreen,
  messagesNotFound,
};
